import * as Yup from 'yup'


/** Dropoff Consignment Inbound Request Receiving schema for Exclusive Seller (no maximum quantity) */
const consignmentInboundRequestReceiveDropoffForExclusiveSellerSchema = Yup.object().shape({
  received_quantity: Yup.number()
    .positive('Must be more than 0')
    .required('Required'),
  received_weight: Yup.number().positive('Must be more than 0').required('Required')
})

export default consignmentInboundRequestReceiveDropoffForExclusiveSellerSchema
